import React from 'react';

const heroImage={
  src: 'https://media-manager-c.questera.ai/greta-media/27e565ca62f331bb3d3ca67ccd492f06cd2fa92619ed72ab1d77f8d98c6e5b4cc6657f2d778fcddfd847ef506ea1c4d1/images/aW1hZ2UvanBlZw==/466943920e591a0f49cb25cf43f09c2f.jpg',
  alt: 'The 90-Day New Manager Toolkit'
};

const productImages=[
  {
    src: 'https://media-manager-c.questera.ai/greta-media/27e565ca62f331bb3d3ca67ccd492f06cd2fa92619ed72ab1d77f8d98c6e5b4cc6657f2d778fcddfd847ef506ea1c4d1/images/aW1hZ2UvanBlZw==/fe277b23ca9b01351a6a8a16dda07412.jpg',
    alt: 'Toolkit scripts preview'
  },
  {
    src: 'https://media-manager-c.questera.ai/greta-media/27e565ca62f331bb3d3ca67ccd492f06cd2fa92619ed72ab1d77f8d98c6e5b4cc6657f2d778fcddfd847ef506ea1c4d1/images/aW1hZ2UvanBlZw==/172bd827e2fd7ef7bc7f4196bc449a8d.jpg',
    alt: 'Toolkit value comparison preview'
  },
  {
    src: 'https://media-manager-c.questera.ai/greta-media/27e565ca62f331bb3d3ca67ccd492f06cd2fa92619ed72ab1d77f8d98c6e5b4cc6657f2d778fcddfd847ef506ea1c4d1/images/aW1hZ2UvanBlZw==/fc772530ce628de15d26131f904e4d61.jpg',
    alt: 'Seven files in the management toolkit preview'
  }
];

function ProductMockup({compact=false,hero=false}) {
  const images=hero ? [heroImage] : compact ? productImages : productImages.slice(0,3);

  return (
    <div className={`product-mockup${compact ? ' product-mockup-compact' : ''}${hero ? ' product-mockup-hero' : ''}`}>
      <div className="product-image-grid">
        {images.map((image,index)=> (
          <figure className={`product-image product-image-${index + 1}`} key={image.src}>
            <img src={image.src} alt={image.alt} />
          </figure>
        ))}
      </div>
    </div>
  );
}

export default ProductMockup;